import React, { useState } from 'react'
import DocumentTitle from '../../../../components/DocumentTitle/DocumentTitle'
import ApcStepper from '../../../../components/APC/StepperAPC/ApcStepper';
import { paymentStepsAPC } from '../../../../utils/texts';
import StepOne from '../../../../components/APC/Paiement/Steps/StepOne';
import StepTwo from '../../../../components/APC/Paiement/Steps/StepTwo';
import StepThree from '../../../../components/APC/Paiement/Steps/StepThree';
import StepFour from '../../../../components/APC/Paiement/Steps/StepFour';

const NouvelleAPC = () => {
 const [ activeStep,setActiveStep ] = useState(1);  

 const handleInput = (e) => {
  const { name, value } = e.target;

  // Special handling for numeroChassis
  if (name === 'numeroChassis') {
    setPaiement(prev => ({
      ...prev,
      infovehicule: {
        ...prev.infovehicule,
        numeroChassis: [value?.toUpperCase()] // Always maintain as array with single item
      }
    }));
    return;
  }

  if (name === 'otherColor') {
    setPaiement(prev => ({
      ...prev,
      infovehicule: {
        ...prev.infovehicule,
        [name]: value // Always maintain as array with single item
      }
    }));
    return;
  }

  if (name === 'couleur') {
    setPaiement(prev => ({
      ...prev,
      infovehicule: {
        ...prev.infovehicule,
        couleur: value,
        otherColor: ''
      }
    }));
    return;
  }

  // Limit RCCM input to 20 characters
  
  if (name === 'rccm') {
    if (value.length <= 20) { // Only update if within limit
      setPaiement(prev => ({
        ...prev,
        demandeur:{
          ...prev.demandeur,
          [name]: value
        }
      }));
    }
    return; // Exit early to avoid other checks
  }

  // Check if the field is in the top level (like typeDemandeur)
  if (name in paiement) {
    setPaiement({
      ...paiement,
      [name]: value
    });
  } 
  // Check if the field is in the demandeur object
  else if (name in paiement.demandeur) {
    setPaiement({
      ...paiement,
      demandeur: {
        ...paiement.demandeur,
        [name]: value
      }
    });
  }
  // Check if the field is in the infovehicule object
  else if (name in paiement.infovehicule) {
    setPaiement({
      ...paiement,
      infovehicule: {
        ...paiement.infovehicule,
        [name]: name === 'ptac' ? Number(value) : value // Convert to number if it's ptac
      }
    });
  }
};
 
 const [ paiement ,setPaiement ] = useState({
     typeDemandeur: '',
     demandeur:{
     fullName:'',
     adresse: '',
     telephone:'',
     email: '',
     nina:'',
     denominationSociete:'',
     rccm: '',
    },
    infovehicule:{ 
     marque: '',
     modele: '',
     numeroChassis:[],
     categorie: '',  
     ptac: 0,
     dateMiseCirculation:'',
     paysProvenance:'Belgique',
     paysDestination:'Guinée',
     dossier:[] ,
     poidsTotalRoulant:0,
     poidsAVide:0,
     puissanceFiscale:0,
     chargeUtile:0,
     couleur:'',
     otherColor:""
    }
 })
 const nextStep = () => {
    if( activeStep <= 4 )
      setActiveStep((s) => s + 1)
  }  
  const prevStep = () => {
    if( activeStep >= 1 ){
        setActiveStep((s) => s - 1);
    }
  } 
  const stepPage = () => {
        switch( activeStep ){
            case 1: 
               return <StepOne
                        setActiveStep={setActiveStep }
                        activeStep={ activeStep }
                        nextStep={nextStep}
                        paiement={paiement}
                        setPaiement={setPaiement}
                        handleInput={handleInput}
                     />;
            case 2: 
               return <StepTwo
                        setActiveStep={setActiveStep }
                        activeStep={ activeStep }
                        nextStep={nextStep}
                        prevStep={prevStep}
                        paiement={paiement}
                        setPaiement={setPaiement}
                        handleInput={handleInput}
                       />   
           case 3:    
               return <StepThree
                        setActiveStep={setActiveStep }
                        activeStep={ activeStep }
                        nextStep={nextStep}
                        prevStep={prevStep}
                        paiement={paiement}
                        setPaiement={setPaiement}
                     /> 
          case 4: 
                return <StepFour
                        setActiveStep={setActiveStep }
                        activeStep={ activeStep }
                        nextStep={nextStep}
                        prevStep={prevStep}
                        paiement={paiement}
                        setPaiement={setPaiement}
                      />                  
        }
  }
  return (
    <div className='payment page'>
      <DocumentTitle title="Paiement Attestation d'enregistrement primaire" /> 
       <div className="header">
            <h3>Paiement Nouvelle Attestation d'enregistrement primaire"</h3>
            <p>Suivez les trois étapes suivantes pour faire un nouveau paiement.</p>
        </div>
        <div className="payment-zone">
           <div className="payment-steps">
             <ApcStepper steps={paymentStepsAPC} activeStep={activeStep} />
           </div> 
           <div className="payment-form">
               { stepPage() }
           </div> 
        </div>    
    </div>
  )
}

export default NouvelleAPC
